import { memo } from "react";
import { FieldTypeEditorProps } from "../types";

export const DateFieldTypeSpecificProps = memo(
  (_props: FieldTypeEditorProps) => null,
);
